<template>
  <HSelect
    id="channel-tags"
    label="Tags"
    placeholder="Exemplo: Alergia; Urgência; etc."
    :value="selectedTags"
    :options="tagOptions"
    option-key="name"
    option-label="name"
    multiple
    @update:value="handleSelect"
    @input="handleInput"
    @focusout="filter = null"
  />
</template>

<script>
import { mapState } from 'vuex'

import { HSelect } from '@/components/shared/atoms'

export default {
  components: { HSelect },
  props: {
    channelTags: {
      type: Array,
      default: () => []
    }
  },
  emits: ['changeTags'],
  data() {
    return {
      selectedTags: [],
      filter: null
    }
  },
  computed: {
    ...mapState('channel', ['tags']),
    tagOptions() {
      return this.tags.filter(tag => {
        const duplicateTag = !this.channelTags.includes(tag.name)
        if (this.filter) {
          return duplicateTag && tag.name.includes(this.filter)
        }
        return duplicateTag
      })
    }
  },
  watch: {
    channelTags: {
      immediate: true,
      handler() {
        this.selectedTags = this.channelTags?.map(name => ({ name })) || []
      }
    }
  },
  mounted() {
    if (!this.tags.length) {
      this.$store.dispatch('channel/fetchTags')
    }
  },
  methods: {
    onInput() {
      const tags = this.selectedTags.map(({ name }) => name)
      this.$emit('changeTags', tags)
    },
    handleSelect(selectedTags) {
      this.selectedTags = selectedTags
      const tags = selectedTags.map(({ name }) => name)
      this.$emit('changeTags', tags)
    },
    handleInput(value) {
      this.filter = value
    }
  }
}
</script>
